
const rawBaseUrl = process.env.REACT_APP_API_HOST || ''
export const baseUrl = rawBaseUrl.trim().replace(/\/+$/, '')

// Base del front de tableros embebibles (Cube). Configurable por env; default prod.
export const dashUrl = (process.env.REACT_APP_DASH_URL || 'https://dash.storehub.cloud')
    .trim()
    .replace(/\/+$/, '')

const appConfig = {
    //apiPrefix: '/api',
    apiPrefix: `${baseUrl}/api/backoffice`,
    dashUrl,
    authenticatedEntryPath: '/home',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '',
    enableMock: false
}

export default appConfig
